import React, { Component } from "react";
import shallowCompare from "react-addons-shallow-compare";
// import equal from 'fast-deep-equal'

// Components
import VariantTitleValue from "./VariantTitleValue";

class Variant extends Component {
	shouldComponentUpdate(nextProps, nextState) {
		return shallowCompare(this, nextProps, nextState);
	}

	render() {
		const { variant, variantIndex, addVariantOption, variantAdditionInProgress } = this.props;

		// console.log('Variant rendered', variant.title)

		return (
			<div className="variant-wrapper" data-new="new_value">
				<div className="ajax-error" data-hbs-id="{{id}}" />
				<div className="varient-item-titles">
					<div className="variant-item-title">Title</div>
					<div className="varient-attribute-titles">
						<div className="variant-attribute">Value</div>
					</div>
				</div>
				<div className="variant-item-content">
					<div className="variant-label">
						<input type="text" name="variant_label" value={variant.title} placeholder="Size, colour, etc." onChange={e => this.props.changeVariantTitle(e, variantIndex)} />
					</div>
					<div className="variant-value-collection">
						<div className="variant-value-wrapper">
							{variant.items.map((item, i) => {
								return <VariantTitleValue key={i} itemIndex={i} item={item} {...this.props} />;
							})}
						</div>
						<button className="add-new-variant-item" disabled={variantAdditionInProgress} onClick={() => addVariantOption(variantIndex)}>
							<span>Add New</span>
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Variant;



// WEBPACK FOOTER //
// ./src/components/admin/products/variants/Variant.js